/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsSwapH: {
  name: 'arrows-swap-h';
  data: string;
} = {
  name: 'arrows-swap-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.707 4.293a1 1 0 1 0-1.414 1.414L17.586 7H12a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Zm-10 9.414a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 17H12a1 1 0 1 0 0-2H6.414l1.293-1.293Z" fill="currentColor"/></svg>`,
};
